import { useEffect } from 'react';
import ReactQuill from 'react-quill';
import { Button, Offcanvas, OffcanvasBody, OffcanvasHeader } from 'reactstrap';
import { yupResolver } from '@hookform/resolvers/yup';
import { Controller, useForm } from 'react-hook-form';
import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import commentsIcon from '../../../../assets/images/performance/commentsIcon.png';
import { initialValues, validationSchema } from './constant';
import { updateKPIComment } from '../../../../store/apis/performanceService';

function KPIComment({
  isOpen,
  toggle,
  kpi,
  refetchPerformanceDetails,
  selectedEmployee,
  isEmployee,
  isCalibrationCompleted,
}) {
  const {
    handleSubmit,
    reset,
    control,
    setValue,
    formState: { errors, isValid },
  } = useForm({
    mode: 'onChange',
    resolver: yupResolver(validationSchema),
    defaultValues: initialValues,
  });

  useEffect(() => {
    reset();
    if (kpi?.KPI_Comments) {
      setValue('comment', kpi.KPI_Comments);
    }
  }, [reset, kpi, setValue]);

  const { mutate: updateComment, isPending } = useMutation({
    mutationFn: updateKPIComment,
    onSuccess: () => {
      toast.success('Comment saved successfully!', {
        className: 'toast-success',
      });
      refetchPerformanceDetails();
    },
    onError: error => {
      toast.error(error?.message || 'Failed to add comment', {
        className: 'toast-error',
      });
    },
  });

  const onSubmit = data => {
    const payload = {
      kpiCategory: kpi?.KPI_Category,
      kpiSeq: kpi?.KPI_Sequence,
      comment: data.comment,
      employeeId: selectedEmployee?.value,
      userId: '',
    };
    updateComment(payload);
    toggle();
    reset();
  };

  return (
    <div>
      <Offcanvas direction="end" isOpen={isOpen} toggle={toggle}>
        <OffcanvasHeader>
          <div className="addKpiHeader ">
            <img alt="" src={commentsIcon} />
            <div className="title">Employee Comments</div>
          </div>
        </OffcanvasHeader>
        <form onSubmit={handleSubmit(onSubmit)}>
          <OffcanvasBody>
            <div className="addKpiBody">
              <div className="kpiInput">
                <div className="kpiDescription">
                  <Controller
                    name="comment"
                    control={control}
                    render={({ field }) => (
                      <ReactQuill
                        value={field.value}
                        onChange={field.onChange}
                        placeholder="Comment"
                        className="my-quill"
                        readOnly={!isEmployee || isCalibrationCompleted}
                      />
                    )}
                  />
                  {errors.comment && (
                    <span className="text-danger">
                      {errors.comment.message}
                    </span>
                  )}
                </div>
              </div>
              {isEmployee && !isCalibrationCompleted && (
                <div className="kpiAction">
                  <Button
                    className="custom-light-btn item"
                    onClick={() => {
                      reset();
                      toggle();
                    }}
                  >
                    Cancel
                  </Button>
                  <Button
                    className="custom-btn item"
                    disabled={!isValid || isPending}
                  >
                    {isPending ? 'Saving...' : 'Save'}
                  </Button>
                </div>
              )}
            </div>
          </OffcanvasBody>
        </form>
      </Offcanvas>
    </div>
  );
}

export default KPIComment;
